import React from 'react'
import { demoThumbnailUrl,  demoVideoTitle, demoChannelUrl, demoChannelTitle, demoVideoUrl } from "../utils/constants";
import { Card, CardContent,  Typography, CardMedia} from '@mui/material';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {Link} from 'react-router-dom';

// Made the hover look more adorable


// Use the medium card thingies 
const VideoCard = ({item, videoId}) => {
  return (
    <Card sx={{
      boxShadow: 'none', 
      width: {md: '320px', sm: '370px', xs: '100%'}, 
      transition: 'all linear 0.3s',
      ":hover": {
        opacity: 0.9
        
      }}
      
      }>
        <Link to={videoId ?  `/video/${videoId}` : demoThumbnailUrl}>
          <CardMedia
              component="img"
              height="180px"
              src={item?.thumbnails?.medium?.url || demoThumbnailUrl}
              alt={demoVideoTitle}
          />
        </Link>
        <CardContent sx={{height: '160px'}}>
            <Link to={videoId ? `/video/${videoId}` : demoVideoUrl}>
              <Typography color="#850E35" variant="subtitle1" fontWeight="bold" gutterBottom>
                  {item?.title?.slice(0, 60) || demoVideoTitle?.slice(0,60) }
              </Typography>
            </Link>
            
            <Link to={videoId ? `/channel/${item.channelId}` : demoChannelUrl}>  
              <Typography variant="subtitle2" color="gray">
                {item?.channelTitle ? item.channelTitle : demoChannelTitle }
              <CheckCircleIcon sx={{fontSize: '15px', ml: 2, color: 'gray'}}/>
              </Typography>
            </Link>
        </CardContent>

        
    </Card>
  )
}

export default VideoCard